import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2101LogicalUnitPersonalizationHandler } from "./U2101LogicalUnitPersonalizationHandlers";

// Typage des props du composant
interface U2101LogicalUnitPersonalizationDeleteDlgProps {
  u2101LogicalUnitPersonalizationHandler: U2101LogicalUnitPersonalizationHandler;
  t: TFunction;
  NS: string;
}

function U2101LogicalUnitPersonalizationDeleteDlg({ u2101LogicalUnitPersonalizationHandler, t, NS }: U2101LogicalUnitPersonalizationDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2101LogicalUnitPersonalizationHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={u2101LogicalUnitPersonalizationHandler.isDeleteDialogOpen}
      onClose={u2101LogicalUnitPersonalizationHandler.onDlgDeleteClose}
      title={t("lblLogicalUnitPersonalization", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeleteLogicalUnitPersonalization", {
          count: u2101LogicalUnitPersonalizationHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2101LogicalUnitPersonalizationHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => (
          <span key={row.logicalUnitPersonalizationCode} className="inline-block text-gray-800">
            {`${row.logicalUnitPersonalizationCode}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2101LogicalUnitPersonalizationDeleteDlg;
